import { useState } from 'react';
import Session from '../shared/Session';
import slugify from 'react-slugify';
import Typography from '@mui/material/Typography';
import { TextField } from '@mui/material';
import { LoadingButton } from '@mui/lab';
import SendIcon from '@mui/icons-material/Send';
import { InputLabel, MenuItem, Select, Stack } from '@mui/material';
import FormControl from '@mui/material/FormControl'


export default function CreateApp() {
    const [app, setApp]: [any, any] = useState({});
    const [config, setConfig]: [any, any] = useState({});
    const [loading, setLoading] = useState(false);
    
    const [loadingDeployments, setLoadingDeployments] = useState(false);
    const [deployments, setDeployments]: [any, any] = useState([]);

    if (!loadingDeployments) {
        setLoadingDeployments(true);
        Session.api("GET", "/deployments/", {}, setDeployments);
    }

    const handleAppChange = (event: any, key: any) => {
        if (key === "name") {
            setApp({ ...app, "slug": slugify(event.target.value) });
        }
        setApp({ ...app, [key]: event.target.value });
    };

    const handleConfigChange = (event: any, key: any) => {
        setConfig({ ...config, [key]: event.target.value });
    };

    let deploymentOptions = [];
    for (const deployment of deployments) {
        deploymentOptions.push(<MenuItem key={deployment.id} value={deployment.id}>{deployment.name} ({deployment.slug})</MenuItem>);
    }

    let varietyOptions = [];
    varietyOptions.push(<MenuItem key="wordpress" value="wordpress">WordPress</MenuItem>);
    varietyOptions.push(<MenuItem key="redirect" value="redirect">Redirect</MenuItem>);
    varietyOptions.push(<MenuItem key="git-repository-directory" value="git-repository-directory">Git Repository (Directory)</MenuItem>);
    varietyOptions.push(<MenuItem key="directory" value="directory">Directory (/public_html)</MenuItem>);
    varietyOptions.push(<MenuItem key="api" value="api">API</MenuItem>);

    let phpOptions = [];
    phpOptions.push(<MenuItem key="74" value="74">7.4</MenuItem>);
    phpOptions.push(<MenuItem key="82" value="82">8.2</MenuItem>);

    return <>
        <Typography variant="h4" align="left" gutterBottom component="h2">
            New Application
        </Typography>
        <form style={{ maxWidth: "480px" }}>
            <Stack spacing={2}>
                <FormControl>
                    <TextField
                        type="text"
                        required={true}
                        value={app["name"]}
                        helperText={"Application Name"}
                        variant="standard"
                        size="medium"
                        onChange={(e) => handleAppChange(e, "name")}
                    />
                </FormControl>
                <FormControl>
                    <TextField
                        type="text"
                        disabled={true}
                        value={app["slug"]}
                        helperText={"Slug"}
                        variant="standard"
                        size="medium"
                        onChange={(e) => handleAppChange(e, "slug")}
                    />
                </FormControl>
                <FormControl>
                    <InputLabel id={"deployment-id-input-label"}>Deployment</InputLabel>
                    <Select
                        labelId={"deployment-id-input-label"}
                        value={app["deployment_id"]}
                        required={true}
                        label={"Deployment"}
                        onChange={(e) => handleAppChange(e, "deployment_id")}
                    >
                        {deploymentOptions}
                    </Select>
                </FormControl>
                <FormControl>
                    <TextField
                        type="text"
                        required={true}
                        value={app["fqdn"]}
                        helperText={"Fully Qualified Domain Name"}
                        variant="standard"
                        size="medium"
                        onChange={(e) => handleAppChange(e, "fqdn")}
                    />
                </FormControl>
                <FormControl>
                    <InputLabel id={"variety-input-label"}>Variety</InputLabel>
                    <Select
                        labelId={"variety-input-label"}
                        value={app["variety"]}
                        required={true}
                        label={"Variety"}
                        onChange={(e) => handleAppChange(e, "variety")}
                    >
                        {varietyOptions}
                    </Select>
                </FormControl>

                {app["variety"] === "git-repository-directory" &&
                    <>
                        <FormControl>
                            <TextField
                                type="text"
                                required={true}
                                value={config["url"]}
                                helperText={"Git Repository URL"}
                                variant="standard"
                                size="medium"
                                onChange={(e) => handleConfigChange(e, "url")}
                            />
                        </FormControl>
                    </>
                }

                {app["variety"] === "redirect" &&
                    <>
                        <FormControl>
                            <TextField
                                type="text"
                                required={true}
                                value={config["url"]}
                                helperText={"Redirect To URL as 301"}
                                variant="standard"
                                size="medium"
                                onChange={(e) => handleConfigChange(e, "url")}
                            />
                        </FormControl>
                    </>
                }

                {app["variety"] === "wordpress" &&
                    <>
                        <FormControl>
                            <InputLabel id={"php-input-label"}>PHP Version</InputLabel>
                            <Select
                                labelId={"php-input-label"}
                                value={config["php_version"]}
                                required={true}
                                label={"PHP Version"}
                                onChange={(e) => handleConfigChange(e, "php_version")}
                            >
                                {phpOptions}
                            </Select>
                        </FormControl>
                        <FormControl>
                            <TextField
                                type="text"
                                multiline
                                minRows={2}
                                maxRows={3}
                                required={true}
                                value={config["admins"]}
                                helperText={"Administrator Emails (Line Separated)"}
                                variant="standard"
                                size="medium"
                                onChange={(e) => { handleConfigChange(e, "admins"); }}
                            />
                        </FormControl>
                    </>
                }

                <LoadingButton
                    onClick={(e) => {
                        e.preventDefault();

                        var postData = { ...app, options: config };

                        setLoading(true);

                        Session.api("POST", "/applications/", postData, (result: any) => {
                            Session.navigate("/applications/edit/" + result.id);
                        });
                    }}
                    type="submit"
                    endIcon={<SendIcon />}
                    loading={loading}
                    loadingPosition="end"
                    size="large"
                    variant="contained"
                >
                    Create {app["name"]}
                </LoadingButton>
            </Stack>
        </form></>
}
